import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import useAdmin from '../../hooks/useAdmin';

const Dashboard = () => {
  const [user] = useAuthState(auth);
  const [admin]= useAdmin(user);
  console.log(admin)
    return (
        <div class="drawer drawer-mobile">
  <input id="dashboard-sidebar" type="checkbox" class="drawer-toggle" />
  <div class="drawer-content ">
      <h2 className='text-3xl font-bold text-purple-500'>Welcome to your Dashboard</h2>
    {/* <!-- Page content here --> */}
    <Outlet></Outlet>
    {/* <label for="my-drawer-2" class="btn btn-primary drawer-button lg:hidden">Open drawer</label> */}
  
  </div> 
  <div class="drawer-side">
    <label for="dashboard-sidebar" class="drawer-overlay"></label> 
    <ul class="menu p-4 overflow-y-auto w-48 bg-base-100 text-base-content">
      {/* <!-- Sidebar content here --> */}
      <li><Link to="/dashboard">My Appointments</Link></li>
      <li><Link to="/dashboard/review">My Reviews</Link></li>
      <li><Link to="/dashboard/history">My History</Link></li>
      {
        admin && <>
         <li><Link to="/dashboard/users">All User</Link></li>
         <li><Link to="/dashboard/addDoctor">Add a Doctor</Link></li>
         <li><Link to="/dashboard/manageDoctor">Manage Doctor</Link></li>
        </>
      }
    </ul>
  
  </div>
</div>
    );
};

export default Dashboard;